import PropTypes from "prop-types";
import React from "react";
import "../components/header.scss";
import { Link } from "gatsby";
import scrollTo from "gatsby-plugin-smoothscroll";
import { injectIntl, FormattedMessage } from "gatsby-plugin-intl";
import Language from "../components/language";

class Header extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      images_count: 0,
      images_loaded: 0,
      color: 'dark',
      colors: []
    }

    // Bind
    this.imageLoaded = this.imageLoaded.bind(this);
    this.componentDidUpdate = this.componentDidUpdate.bind(this);
    this.colorChangeInit = this.colorChangeInit.bind(this);
    this.colorChangeScroll = this.colorChangeScroll.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
  }

  imageLoaded(event) {
    if (event && event.target) event.target.removeEventListener('load', this.imageLoaded);

    this.setState((prevState) => {
      return {images_loaded: prevState.images_loaded + 1};
    })

    // Init color header when 
    if (this.state.images_count === this.state.images_loaded) this.colorChangeInit();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.mount.length === this.props.mount.length) return;
    
    const sections = document.querySelectorAll('.section');

    // All components are loaded
    if (this.props.mount.length === sections.length) {
      // But we have to wait for all images load, to have the right top of each sections.
      // Get all images
      const images = document.querySelectorAll('img');
      this.setState({images_count : images.length});

      // Add load listener on all images
      for (let i = 0; i < images.length; i++) {
        if (images[i].complete) {
          this.imageLoaded();
        } else {
          images[i].addEventListener('load', this.imageLoaded, false);
        }
      }
    }
  }

  colorChangeInit() {
    const sections = document.querySelectorAll('.section');
    const body_rect = document.body.getBoundingClientRect();
    
    // Create array with color and position
    for (let i = 0; i < sections.length; i++) {
      const section = sections[i];
      const offset = section.getBoundingClientRect().top - body_rect.top;

      this.setState((prevState) => {
        return {colors: [
          ...prevState.colors, 
          {
          'section': section.className,
          'state': section.getAttribute('data-header-color'),
          'position': {
            'in' : Math.round(offset),
            'out' : sections[i + 1] ? 
              Math.round(sections[i + 1].getBoundingClientRect().top - body_rect.top) : 
              Math.round(section.parentElement.getBoundingClientRect().bottom)
            }
          }
        ]};
      });
    }

    // Init scroll
    document.addEventListener("scroll", this.colorChangeScroll, false);
  }

  colorChangeScroll() {
    // Check the header color for this current scroll position
    for (let i = 0; i < this.state.colors.length; i++) {
      const color = this.state.colors[i];
      if (
        document.documentElement.scrollTop >= color.position.in
        && document.documentElement.scrollTop < color.position.out
      ) {
        if (this.state.color !== color.state) this.setState({color: color.state});
        break;
      }
    }
  }

  componentWillUnmount(){
    // Unmount listener for scoll
    document.removeEventListener("scroll", this.colorChangeScroll, false);
  }

  render() {
    return (
      <header className={this.state.color}>
        <div className="header__wrapper">
          <Link to="/">
            <svg
              width="69"
              height="44"
              viewBox="0 0 69 44"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="logo"
                d="M12.1809 2.13592C10.7315.711975 8.94754 0 6.82912 0c-1.5052 0-2.81527.427184-3.90236 1.25308-1.08708.82588-1.61668 1.99352-1.61668 3.47443 0 1.25307.39023 2.27832 1.1707 2.99029.78047.68349 1.3937 1.05372 2.42504 1.53786.25086.11392.94771.42719 1.19857.56958.25087.11392.7526.34176.94772.54106.39023.2564.6411.6266.6411 1.0253 0 .655-.86409.9967-1.61669.9967-1.42157 0-2.28566-.5411-3.62361-1.8796L0 13.2427c1.86755 1.7942 3.98597 2.7055 6.32739 2.7055 1.58881 0 2.98251-.4272 4.12531-1.2815 1.1429-.8829 1.7282-2.1075 1.7282-3.6738 0-1.13918-.5017-2.13594-.9477-2.70552-.223-.28479-.5854-.56958-1.0871-.88285-.50171-.31327-.86408-.51262-1.11494-.59806l-1.19858-.5411c-1.47732-.65501-2.20204-1.0822-2.20204-1.87961 0-.48414.55748-.82589 1.19858-.82589 1.03133 0 2.00692.42719 2.92676 1.31003l2.42502-2.73398zM27.9907 6.46473C27.9907 2.39223 25.7886 0 21.7469 0c-2.2578 0-4.4598.5411-6.6061 1.6233l1.1707 3.16117c1.7003-.88285 3.1776-1.31004 4.4319-1.31004 1.9791 0 2.7317 1.02525 2.7317 2.87638v.11392c-.8641-.19936-1.7282-.31327-2.5644-.31327-1.7561 0-3.2891.3987-4.5713 1.16763-1.2544.76894-1.8955 2.02201-1.8955 3.70231 0 1.4809.5296 2.677 1.5888 3.5883 1.0871.8829 2.3415 1.3385 3.8188 1.3385 1.8397 0 3.1497-.5126 3.9302-1.5378l.4181 1.1961h3.7909V6.46473zm-4.5156 5.29707c-.7805.7405-1.6446 1.1107-2.5923 1.1107-1.1149 0-2.0348-.7405-2.0348-1.8511 0-1.50943 1.2822-2.2214 2.8432-2.2214.4181 0 1.0313.08544 1.7839.25631v2.70549zM44.3231 6.46473C44.3231 2.39223 42.121 0 38.0793 0c-2.2578 0-4.4598.5411-6.6061 1.6233l1.1707 3.16117c1.7003-.88285 3.1776-1.31004 4.4319-1.31004 1.9791 0 2.7317 1.02525 2.7317 2.87638v.11392c-.8641-.19936-1.7282-.31327-2.5644-.31327-1.7561 0-3.2891.3987-4.5714 1.16763-1.2543.76894-1.8954 2.02201-1.8954 3.70231 0 1.4809.5296 2.677 1.5888 3.5883 1.0871.8829 2.3414 1.3385 3.8188 1.3385 1.8396 0 3.1497-.5126 3.9302-1.5378l.4181 1.1961h3.7909V6.46473zm-4.5156 5.29707c-.7805.7405-1.6446 1.1107-2.5923 1.1107-1.115 0-2.0348-.7405-2.0348-1.8511 0-1.50943 1.2822-2.2214 2.8431-2.2214.4182 0 1.0314.08544 1.784.25631v2.70549zM58.5649 2.13592C57.1155.711975 55.3315 0 53.2131 0c-1.5052 0-2.8153.427184-3.9023 1.25308-1.0871.82588-1.6167 1.99352-1.6167 3.47443 0 1.25307.3902 2.27832 1.1707 2.99029.7804.68349 1.3937 1.05372 2.425 1.53786.2509.11392.9477.42719 1.1986.56958.2509.11392.7526.34176.9477.54106.3902.2564.6411.6266.6411 1.0253 0 .655-.8641.9967-1.6167.9967-1.4216 0-2.2857-.5411-3.6236-1.8796l-2.4529 2.734c1.8675 1.7942 3.986 2.7055 6.3274 2.7055 1.5888 0 2.9825-.4272 4.1253-1.2815 1.1429-.8829 1.7282-2.1075 1.7282-3.6738 0-1.13918-.5017-2.13594-.9477-2.70552-.223-.28479-.5854-.56958-1.0871-.88285-.5017-.31327-.8641-.51262-1.115-.59806l-1.1985-.5411c-1.4773-.65501-2.2021-1.0822-2.2021-1.87961 0-.48414.5575-.82589 1.1986-.82589 1.0313 0 2.0069.42719 2.9268 1.31003l2.425-2.73398zM12.1809 23.4951c-1.4494-1.4239-3.23336-2.1359-5.35178-2.1359-1.5052 0-2.81527.4272-3.90236 1.2531-1.08708.8259-1.61668 1.9935-1.61668 3.4744 0 1.2531.39023 2.2783 1.1707 2.9903.78047.6835 1.3937 1.0537 2.42504 1.5379.25086.1139.94771.4272 1.19857.5696.25087.1139.7526.3417.94772.5411.39023.2563.6411.6265.6411 1.0252 0 .655-.86409.9968-1.61669.9968-1.42157 0-2.28566-.5411-3.62361-1.8796L0 34.6019c1.86755 1.7942 3.98597 2.7055 6.32739 2.7055 1.58881 0 2.98251-.4271 4.12531-1.2815 1.1429-.8829 1.7282-2.1075 1.7282-3.6738 0-1.1392-.5017-2.1359-.9477-2.7055-.223-.2848-.5854-.5696-1.0871-.8828-.50171-.3133-.86408-.5127-1.11494-.5981l-1.19858-.5411c-1.47732-.655-2.20204-1.0822-2.20204-1.8796 0-.4842.55748-.8259 1.19858-.8259 1.03133 0 2.00692.4272 2.92676 1.31l2.42502-2.734zM23.503 21.701h-3.6794v-3.2751h-3.6794l-.8362 3.2751h-1.7003v3.7592h1.7003v5.9236c0 .9968.0558 1.7942.1951 2.3638.5296 2.1929 2.2021 3.5598 4.6271 3.5598 1.5052 0 2.7874-.3132 3.8466-.9398l-1.4215-3.3605c-.5297.2848-1.0593.4272-1.6167.4272-.5575 0-.892-.3417-1.0314-1.0252-.0557-.3133-.0836-.769-.0836-1.367v-5.5819h3.6794V21.701zM27.2827 23.6375c-1.4773 1.5094-2.2299 3.4175-2.2299 5.6958s.7526 4.1864 2.2299 5.6958c1.4773 1.5094 3.3728 2.2783 5.6584 2.2783 2.2857 0 4.1811-.7689 5.6584-2.2783 1.4774-1.5094 2.23-3.4175 2.23-5.6958s-.7526-4.1864-2.23-5.6958c-1.4773-1.5093-3.3727-2.2783-5.6584-2.2783-2.2856 0-4.1811.769-5.6584 2.2783zm8.0556 8.6292c-.6132.7689-1.4216 1.1676-2.3972 1.1676-.9756 0-1.7839-.3987-2.3971-1.1676-.6133-.769-.9199-1.7657-.9199-2.9334 0-1.1676.3066-2.1644.9199-2.9333.6132-.7689 1.4215-1.1676 2.3971-1.1676s1.784.3987 2.3972 1.1676c.6132.7689.9198 1.7657.9198 2.9333 0 1.1677-.3066 2.1644-.9198 2.9334zM43.4211 21.701v15.2647h4.5156V26.6278c.5296-.8259 1.533-1.3954 2.5365-1.3954.5296 0 1.0035.1139 1.4216.3417l1.1149-3.8162c-.6132-.2563-1.2822-.3987-2.0069-.3987-1.3101 0-2.4529.712-3.3728 2.1644l-.3902-1.8226h-3.8187zM58.9375 35.912l-2.3972 6.4932L60.5821 44 69 21.701h-4.8779l-2.7596 8.4013h-.0557l-2.6759-8.4013h-4.9058l5.2124 14.211z"
                fill="#05293D"
              />
            </svg>
          </Link>

          <ul className="nav">
            <li className="nav__item">
              <button onClick={() => scrollTo(".products")}><FormattedMessage id="main__nav.products" /></button>
            </li>{" "}
            <li className="nav__item">
              <button onClick={() => scrollTo(".services")}><FormattedMessage id="main__nav.services" /></button>
            </li>{" "}
            <li className="nav__item">
              <button onClick={() => scrollTo(".process")}><FormattedMessage id="main__nav.process" /></button>
            </li>
            <li className="nav__item">
              <button onClick={() => scrollTo(".clients")}><FormattedMessage id="main__nav.clients" /></button>
            </li>{" "}
            <li className="nav__item">
              <button onClick={() => scrollTo(".contact")}><FormattedMessage id="main__nav.contact" /></button>
            </li>{" "}
          </ul>
          <div className="lang__switcher">
            <Language />
          </div>
        </div>
      </header>
    );
  }
}

Header.propTypes = {
  siteTitle: PropTypes.string
};

Header.defaultProps = {
  siteTitle: ``
};

export default injectIntl(Header);
